import NewModals from "../components/new-modals";

export default class AutomizerModal {
  constructor() {
    this.$modalContainer = $("#automizer-modal");

    if (!this.$modalContainer.length) {
      return;
    }
  }

  openModal() {
    NewModals.open("automizer-modal");
  }
}
